import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes } from "./allRoutes";

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={<VerticalLayout>{route.component}</VerticalLayout>}
                            key={idx}
                        // exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;